import actions from "./actions";

const initState = {
    defaultCurrency:"$",
    
    loginData: null,
    loginLoading: false,
    loginMessage: null,
    loginError: null,

    verifyOtpresult: null,
    verifyOtpLoading: false,
    verifyOtpMessage: null,
    verifyOtpError: null,

    loading: false,
    tokenData: [],
    tokenError: null,

    forgotPasswordLoading: false,
    forgotPasswordMessage: null,
    forgotPasswordError: null,

    resetPasswordLoading: false,
    resetPasswordMessage: null,
    resetPasswordError: null,
};

export default function reducer(state = initState, action) {
    switch (action.type) {
        case actions.LOGIN:
            return {
                ...state,
                loginLoading: true,
                loginMessage: null,
                loginError: null,
            };
        case actions.LOGIN_SUCCESS:
            return {
                ...state,
                loginLoading: false,
                loginData: action.payload.data,
                loginMessage: action.payload.message,
                loginError: null,
            };
        case actions.LOGIN_FAILED:
            return {
                ...state,
                loginLoading: false,
                loginMessage: null,
                loginError: action.payload.error,
            };

        case actions.VERIFY_OTP:
            return {
                ...state,
                verifyOtpLoading: true,
                verifyOtpMessage: null,
                verifyOtpError: null,
            };
        case actions.VERIFY_OTP_SUCCESS:
            return {
                ...state,
                verifyOtpLoading: false,
                verifyOtpresult: action.payload.result,
                verifyOtpMessage: action.payload.message,
                verifyOtpError: null,
            };
        case actions.VERIFY_OTP_FAILED:
            return {
                ...state,
                verifyOtpLoading: false,
                verifyOtpMessage: null,
                verifyOtpError: action.payload.error,
            };

        case actions.RESET_MESSAGE:
            return {
                ...state,
                verifyOtpMessage: null,
                verifyOtpError: null,
                loginMessage: null,
                loginError: null,
                 forgotPasswordMessage: null,
                forgotPasswordError: null,
                resetPasswordMessage: null,
                resetPasswordError: null,
            };

        case actions.GET_USER_DATA_BY_TOKEN:
            return {
                ...state,
                loading: true,
                tokenError: null
            };
        case actions.GET_USER_DATA_BY_TOKEN_SUCCESS:
            return {
                ...state,
                loading: false,
                tokenData: action.tokenData
            };
        case actions.GET_USER_DATA_BY_TOKEN_FAILED:
            return {
                ...state,
                loading: false,
                tokenError: action.tokenError
            };

        case actions.FORGOT_PASSWORD:
            return {
                ...state,
                forgotPasswordLoading: true,
                forgotPasswordMessage: null,
                forgotPasswordError: null,
            };
        case actions.FORGOT_PASSWORD_SUCCESS:
            return {
                ...state,
                forgotPasswordLoading: false,
                forgotPasswordMessage: action.payload.message,
                forgotPasswordError: null,
            };
        case actions.FORGOT_PASSWORD_FAILED:
            return {
                ...state,
                forgotPasswordLoading: false,
                forgotPasswordMessage: null,
                forgotPasswordError: action.payload.error,
            };

            case actions.RESET_MESSAGE:
            return {
                ...state,
                 loginMessage: null,
                    loginError: null,
                    verifyOtpMessage: null,
                    verifyOtpError: null,
                forgotPasswordMessage: null,
                forgotPasswordError: null,
                forgotPasswordReqMessage: null,
                forgotPasswordReqError: null,
                 resetPasswordMessage: null,
        resetPasswordError: null,
            };

              case actions.RESET_PASSWORD:
            return {
                ...state,
                resetPasswordLoading: true,
                resetPasswordMessage: null,
                resetPasswordError: null,
            };
        case actions.RESET_PASSWORD_SUCCESS:
            return {
                ...state,
                resetPasswordLoading: false,
                resetPasswordMessage: action.payload.message,
                resetPasswordError: null,
            };
        case actions.RESET_PASSWORD_FAILED:
            return {
                ...state,
                resetPasswordLoading: false,
                resetPasswordMessage: null,
                resetPasswordError: action.payload.error,
            };

        default:
            return state;
    }
}
